import { useGameStore } from 'src/store/game'
import type { InventoryItem } from '../types/domain'

export const getApplicableGamesText = (
  item: InventoryItem, 
  isApplicableToGame: boolean,
  t: (key: string, params?: any) => string
): string => {
  if (isApplicableToGame || item.applicableGames.length === 0) {
    return ''
  }
  
  const state = useGameStore.getState()
  const gameNames = item.applicableGames
    .map(gameId => {
      const game = state.games.byId[gameId]
      const track = game ? state.tracks.byId[game.trackId] : null
      return track?.name
    })
    .filter(Boolean)
  
  if (gameNames.length === 0) {
    return ''
  }
  
  return t('Available for {{games}}', { games: gameNames.join(', ') })
}